import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import useUserContext from '../../../hooks/useUserContext';
import useAPI from '../../../hooks/useAPI';
import ForbiddenAccess from '../../ForrbiddenAccessComponent/ForbiddenAccess';
import BackBtn from '../../UI/BackBtn';
import PartFact from '../../../pages/index/PartFact';
import { groupBy, mapUnits } from '../../../helpers/kpiVals';
import Index from '../../../pages/Index';
import PartUnifiedTable from '../../../pages/index/PartUnifiedTable';
import UnifiedIndicatorsCalculation from '../UnifiedIndicatorsCalculation';
import P2p from '../../../pages/p2p/P2p';
import { hasPermsOnIndexesOrReceipts, isAdminReadRestrictedOrModerator } from '../../../services/rolesSvc';

function IndexPage() {
  const { type } = useParams();
  const userCtx = useUserContext();
  const api = useAPI();
  const [content, setContent] = useState(null);
  const [{
    basePart, specialPart, noPart, factPart,
  }, setPart] = useState({
    basePart: [], specialPart: [], noPart: [], factPart: [],
  });

  useEffect(() => {
    const fetchGroupedIndexes = async () => api.get('/info/kpivals')
      .then((result) => groupBy(result.map(mapUnits), (index) => index.type));

    fetchGroupedIndexes().then((grouped) => {
      setPart({
        basePart: grouped?.get ? grouped?.get('Целевые показатели эффективности реализации программы развития университета, получающего базовую часть гранта') : [],
        specialPart: grouped?.get ? grouped?.get('Целевые показатели эффективности реализации программы развития университета, получающего специальную часть гранта') : [],
        noPart: grouped?.get ? grouped?.get('Показатели, необходимые для достижения результата предоставления гранта') : [],
        factPart: grouped?.get ? grouped?.get('Данные для расчета фактических значений по показателям') : [],
      });
    });
  }, [type]);

  useEffect(() => {
    setContent([
      { type: 'base-part', header: 'Целевые показатели эффективности (базовая часть гранта)', content: renderPage('base-part', basePart, 'Целевые показатели эффективности (базовая часть гранта)') },
      { type: 'special-part', header: 'Целевые показатели эффективности (специальная часть гранта)', content: renderPage('special-part', specialPart, 'Целевые показатели эффективности (специальная часть гранта)') },
      { type: 'no-part', header: 'Показатели достижения результата', content: renderPage('no-part', noPart, 'Показатели достижения результата') },
      {
        type: 'fact-part', header: 'Данные для расчета фактических значений по показателям', content: <PartFact />,
      },
      { type: 'unified-part', content: <PartUnifiedTable/>, show: () => hasPermsOnIndexesOrReceipts(userCtx)},
      { type: 'calculation-unified-part', content: <UnifiedIndicatorsCalculation/>, show: isAdminReadRestrictedOrModerator },
      { type: 'p2p', content: <P2p/> },
    ]);
  }, [basePart, specialPart, noPart, factPart, userCtx]);

  const renderPage = (u, d, n) => d && <Index data={d} name={n} />;
  return (
    <section className="page project-page">
      <div style={{ padding: '3rem' }}>
        <BackBtn />
        {content?.find((x) => x.type === type)?.header
          && (
            <div className="project-title-wrapper" style={{ paddingBottom: '0', color: '#0C0065' }}>
              <h2>{content?.find((x) => x.type === type)?.header}</h2>
            </div>
          )
        }
        <div>
          {content?.filter((x) => x.type === type && (!x.show || x.show(userCtx.perms)))[0]?.content ?? <ForbiddenAccess />}
        </div>
      </div>
    </section>
  );
}

export default IndexPage;
